exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".assign-site-to-user .ReactTable .rt-thead.-filters .ui.input {\n  border: none;\n  margin: 0;\n  width: 100%;\n}\n.assign-site-to-user .ReactTable .rt-thead.-filters input {\n  border: none;\n  border-radius: 0;\n  margin: 0;\n  padding: 0.75rem;\n  width: 100%;\n}\n.assign-site-to-user .ReactTable .rt-thead.-filters .ui.dropdown,\n.assign-site-to-user .ReactTable .rt-thead.-filters .ui.dropdown.active {\n  border: none;\n  margin: 0;\n  width: 100%;\n}\n.assign-site-to-user .ReactTable .rt-thead.-filters .ui.dropdown .text,\n.assign-site-to-user .ReactTable .rt-thead.-filters .ui.dropdown.active .text {\n  max-width: 100% !important;\n}\n.assign-site-to-user .ReactTable .rt-thead.-filters .rt-th .ui.checkbox {\n  margin-top: 0.5rem;\n}\n.nested--react-table {\n  margin: 1em 0.5em;\n  width: auto !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/usersetup/index.less
// module id = 2950
// module chunks = 0